export default __webpack_public_path__ + "static/3-a2eace0903db1456e8fa8a0fe312508e.png";